import {Button} from '../../atoms/Button/Button'
import {cn} from '@/helpers/shadcn/utils'

/**
 * reusable page-wide save actions. 
 * @param {{
 *   visible?: boolean,
 *   changedItemsCount?: number,
 *   isSaving?: boolean,
 *   saveDisabled?: boolean,
 *   discardDisabled?: boolean,
 *   statusLabel?: string,
 *   feedback?: import('react').ReactNode,
 *   onSave: () => void,
 *   onDiscard: () => void,
 *   className?: string,
 * }} props
 */
export const SaveFooter = ({
  visible = true,
  changedItemsCount = 0,
  isSaving = false,
  saveDisabled = false,
  discardDisabled = false,
  statusLabel = 'Editing',
  feedback,
  onSave,
  onDiscard,
  className,
}) => {
  if (!visible) return null

  return (
    <div
      role="region"
      aria-label="Unsaved changes"
      aria-busy={isSaving}
      className={cn(
        'sticky bottom-0 z-10 flex flex-wrap items-center justify-between gap-4 border-t border-[var(--color-border-default)] bg-[var(--color-background-layer-01)] p-4 text-[var(--color-text-primary)]',
        className
      )}
    >
      <div className="flex flex-wrap items-center gap-2" role="status" aria-live="polite">
        <span className="font-semibold">{statusLabel}</span>
        <span>
          &middot; {changedItemsCount} unsaved change{changedItemsCount === 1 ? '' : 's'}
        </span>
        {feedback}
      </div>
      <div className="flex items-center gap-3">
        <Button
          type="button"
          text="Discard changes"
          variant="auxiliary"
          size="medium"
          disabled={isSaving || discardDisabled}
          onClick={onDiscard}
        />
        <Button
          type="button"
          text="Save changes"
          variant="primary"
          size="medium"
          isLoading={isSaving}
          loadingText="Saving"
          disabled={isSaving || saveDisabled}
          onClick={onSave}
        />
      </div>
    </div>
  )
}
